export default "__VITE_PUBLIC_ASSET__2ed3738f__"